export const isValidUsPhone = (value = '') => {
  const digits = value.replace(/\D/g, '');
  if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return false;
  if (/(\d)\1{6,}/.test(digits)) return false;
  if (['0123456789', '1234567890', '9876543210', '0987654321'].includes(digits)) return false;
  if (/^555555/.test(digits) || /^\d{3}55501\d{2}$/.test(digits)) return false;
  return true;
};

export const limitUsPhone = (value = '') => {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const isValidEmail = (value = '') => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
